import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { FaCalendarCheck } from 'react-icons/fa';
import { FaCarSide } from 'react-icons/fa';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { useForm, SubmitHandler } from 'react-hook-form';
import * as Yup from 'yup';
import dayjs from 'dayjs';
import Lottie from 'lottie-react';
import React, { useEffect, useState, useRef } from 'react';

import { Popover } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';

import {
  fetchVehicles,
  // setResetSidebarFilters,
  fetchFilterData,
  setSidebarFilters,
  addContactUs,
  resetContactUs,
  setLimit,
  setSortBy,
} from '../../core/data/redux/action';
import { all_routes } from '../router/all_routes';
import { AppDispatch, RootState } from '../../core/data/redux/store';

import {
  formatDateWithTime,
  generateTimeOptions,
} from '../../core/data/redux/actions/commonActions';
import ContactConfirm from '../../core/data/modals/contactConfirm';
import EnquiryForm from '../../core/data/modals/enquiry';
import ImageWithBasePath from '../../core/data/img/ImageWithBasePath';
import Loader from '../../core/data/img/car_loading.json';
import MobileFilterSidebar from '../common/FilterSidebar';
import Pagination from '../common/pagination';

const VehicleListGrid: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { limit, sortBy } = useSelector((state: RootState) => state.sortFilter);
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const { user, contactUsSuccess, contactUsError, contactUsLoading } =
    useSelector((state: RootState) => ({
      user: state.auth.user,
      contactUsLoading: state.contactUs.contactUsLoading,
      contactUsSuccess: state.contactUs.contactUsSuccess,
      contactUsError: state.contactUs.contactUsError,
    }));

  const handleClose = () => {
    setAnchorEl(null);
  };
  const navigate = useNavigate();
  const openFilter = Boolean(anchorEl);
  const id = openFilter ? 'filter-popover' : undefined;
  const { cars, loading, totalPages, currentPage } = useSelector(
    (state: RootState) => state.vehicle
  );
  const { systemSettings } = useSelector((state: RootState) => state.auth);
  const [open, setOpen] = useState(false);
  const popoverRef = useRef(null);
  const [showCalendar, setShowCalendar] = useState(false);
  const sidebarFilterState = useSelector(
    (state: RootState) => state.sidebarFilter
  );
  const selectedFilters = sidebarFilterState?.selectedFilters || {};
  const [carsList, setCarsList] = useState([]);
  const [carDetail, setCarDetail] = useState<any>([]);
  const [toastMessage, setToastMessage] = useState('');
  const [toastClass, setToastClass] = useState('bg-success text-white');

  useEffect(() => {
    // dispatch(setResetSidebarFilters({}));
    // dispatch(setSidebarFilters({}));

    window.scrollTo(0, 0);
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchFilterData());
  }, []);

  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    if (cars) {
      setCarsList(cars || []);
    }
  }, [cars]);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const getParam = (key: string) => {
    const value = queryParams.get(key);
    return value ? decodeURIComponent(value) : null;
  };

  const today = new Date();
  const tomorrow = new Date();
  tomorrow.setDate(
    tomorrow.getDate() + parseInt(systemSettings.booking_min_duration ?? 7)
  );

  const [startDate, setStartDate] = useState<Date | null>(
    getParam('pickupDate') ? dayjs(getParam('pickupDate')).toDate() : today
  );

  const [endDate, setEndDate] = useState<Date | null>(
    getParam('pickupTime') ? dayjs(getParam('returnDate')).toDate() : tomorrow
  );

  const [fromTime, setFromTime] = useState(
    getParam('pickupTime') ?? systemSettings?.booking_start_time
  );
  const [untilTime, setUntilTime] = useState(
    getParam('returnTime') ?? systemSettings?.booking_end_time
  );
  const [timeOptions, setTimeOptions] = useState<string[]>([]);

  const [availabilityStartDate, setAvailabilityStartDate] =
    useState<Date | null>(
      getParam('pickupDate') ? dayjs(getParam('pickupDate')).toDate() : today
    );

  const [availabilityEndDate, setAvailabilityEndDate] = useState<Date | null>(
    getParam('pickupTime') ? dayjs(getParam('returnDate')).toDate() : tomorrow
  );

  const [availabilityFromTime, setAvailabilityFromTime] = useState(
    getParam('pickupTime') ?? systemSettings?.booking_start_time
  );
  const [availabilityUntilTime, setAvailabilityUntilTime] = useState(
    getParam('returnTime') ?? systemSettings?.booking_end_time
  );

  useEffect(() => {
    if (startDate && endDate) {
      setAvailabilityStartDate(startDate);
      setAvailabilityEndDate(startDate);
    }

    if (fromTime && untilTime) {
      setAvailabilityFromTime(fromTime);
      setAvailabilityUntilTime(untilTime);
    }
  }, [startDate, endDate, fromTime, untilTime]);

  useEffect(() => {
    if (
      systemSettings?.booking_start_time &&
      systemSettings?.booking_end_time
    ) {
      const options = generateTimeOptions(
        systemSettings.booking_start_time,
        systemSettings.booking_end_time,
        0
      );
      setTimeOptions(options);
    }
  }, [systemSettings]);

  useEffect(() => {
    try {
      const formattedStart = formatDateWithTime(startDate, fromTime);
      const formattedEnd = formatDateWithTime(endDate, untilTime);

      if (!formattedStart || !formattedEnd) {
        navigate(routes.homeOne);
      }
    } catch (error) {
      navigate(routes.homeOne);
    }
  }, []);

  useEffect(() => {
    if (startDate && endDate) {
      const newFilters = {
        ...selectedFilters,
        body_style: selectedFilters?.body_style,
        searchText,
      };

      dispatch(
        fetchVehicles(
          1,
          limit,
          sortBy,
          formatDateWithTime(startDate, fromTime),
          formatDateWithTime(endDate, untilTime),
          {
            ...newFilters,
            body_style: selectedFilters?.body_style,
          }
        )
      );
    }
  }, [dispatch, limit, sortBy, startDate, endDate]);

  const handlePageChange = (newPage: number) => {
    if (startDate && endDate) {
      const newFilters = {
        ...selectedFilters,
        body_style: selectedFilters?.body_style,
        searchText,
      };
      dispatch(
        fetchVehicles(
          newPage,
          limit,
          sortBy,
          formatDateWithTime(startDate, fromTime),
          formatDateWithTime(endDate, untilTime),
          newFilters
        )
      );
    }
  };

  const findSimilarCars = (newFilters: any) => {
    if (startDate && endDate) {
      dispatch(
        fetchVehicles(
          1,
          limit,
          sortBy,
          formatDateWithTime(startDate, fromTime),
          formatDateWithTime(endDate, untilTime),
          newFilters
        )
      );
    }
  };

  const applyFilters = (selectedFilters: any) => {
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    const newFilters = { ...selectedFilters, searchText };
    if (startDate && endDate) {
      dispatch(
        fetchVehicles(
          1,
          limit,
          sortBy,
          formatDateWithTime(startDate, fromTime),
          formatDateWithTime(endDate, untilTime),
          newFilters
        )
      );
    }
  };

  const handleSearchClick = () => { 
      const newFilters = { ...selectedFilters, searchText };
      dispatch(setSidebarFilters(newFilters));
      applyFilters(newFilters);
     
  };

  const routes = all_routes;
  const sortOptions = [
    { name: 'Popularity', value: 'popularity' },
    { name: 'Relevance', value: 'relevance' },
    { name: 'Price', value: 'price' },
    { name: 'Year', value: 'year' },
  ];

  const numberOptions = [
    { name: '5', value: 5 },
    { name: '10', value: 10 },
    { name: '20', value: 20 },
    { name: '30', value: 30 },
    { name: '50', value: 50 },
    { name: '100', value: 100 },
  ];

  const initialSortDirection = sortOptions.reduce(
    (acc, option) => {
      acc[option.value] = 'desc';
      return acc;
    },
    {} as Record<string, string>
  );

  const [sortDirection, setSortDirection] = useState(initialSortDirection);

  const handleSortChange = (option: string) => {
    setSortDirection((prevState) => {
      const currentDirection = prevState[option];
      const newDirection = currentDirection === 'asc' ? 'desc' : 'asc';
      const updatedDirections: Record<string, string> = {};
      Object.keys(prevState).forEach((key) => {
        updatedDirections[key] = 'desc';
      });

      updatedDirections[option] = newDirection;
      dispatch(setSortBy(`${option}_${newDirection}`));
      return updatedDirections;
    });
    handleClose();
  };

  const formatLabel = (key: string, includeSuffix = false) => {
    const parts = key.split('_');
    if (!includeSuffix) parts.pop();
    return parts
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  type ContactFormValues = {
    name: string;
    email: string;
    message: string;
    phone: string;
    is_sms_alert_approved: boolean;
  };

  const ContactSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    email: Yup.string().email('Invalid email').required('Email is required'),
    message: Yup.string().required('Message is required'),
    phone: Yup.string().when('$phone', {
      is: (value: any) => value?.trim().length > 0, // Check if phone is not empty
      then: (schema) => schema.length(10, 'Phone must be exactly 10 digits'),
      otherwise: (schema) => schema.notRequired(), // Don't validate if empty
    }),
    is_sms_alert_approved: Yup.boolean().notRequired(),
  });

  const {
    register: contactRegister,
    handleSubmit: contactHandleSubmit,
    formState: { errors: contactErrors },
    reset: contactReset,
    // watch,
    // setValue,
    // trigger,
  } = useForm<ContactFormValues>({
    resolver: yupResolver(ContactSchema),
    defaultValues: {
      name: user?.name,
      email: user?.email,
      message: '',
      phone: user?.mobile,
      is_sms_alert_approved: false,
    },
  });

  const contactOnSubmit: SubmitHandler<ContactFormValues> = (data) => {
    const currentUrl = `${window.location.origin}${routes.listingDetails}/${carDetail?.vin}${location.search}`;

    dispatch(
      addContactUs({
        ...data,
            is_sms_alert_approved: data?.is_sms_alert_approved?1:0,
        query_type: 'enquiry',
        vehicle_id: carDetail?.id,
        ...(carDetail?.vehicle_current_status === 'Booked' && {
          start_date: formatDateWithTime(
            availabilityStartDate,
            availabilityFromTime
          ),
          end_date: formatDateWithTime(
            availabilityEndDate,
            availabilityUntilTime
          ),
          query_type: 'check_availability',
        }),
        fairental_message: `Hi Fairental team, we have a car enquiry from a customer ${data?.name}, ${data.phone}, ${data.email}, Enquiry :${data.message}, please click on the link to see the car details: ${currentUrl}`,
      })
    );

    const encodedMessage = encodeURIComponent(
      `Hi Fairental team, we have a car enquiry from a customer ${data?.name}, ${data.phone}, ${data.email}, Enquiry :${data.message}, please click on the link to see the car details: ${currentUrl}`
    );

    const value = {
      encodedMessage: encodedMessage,
      timestamp: new Date().getTime(),
      currentUrl: currentUrl,
    };

    sessionStorage.setItem('contactForm', JSON.stringify(value));
  };

 
  useEffect(() => {
    if (user) {
      contactReset({
        name: user.name ?? '',
        email: user.email ?? '',
        phone: user.mobile ?? '',
        message: '',
      });
    }
  }, [user, contactReset, contactUsSuccess]);

  useEffect(() => {
    if (contactUsSuccess) {
      showToast(contactUsSuccess);

      closeModal();
      dispatch(resetContactUs());
    } else if (contactUsError) {
      showToast(contactUsError);
      dispatch(resetContactUs());
    }
  }, [contactUsSuccess, contactUsError]);

  const showToast = (message: any) => {
    setToastClass(
      contactUsError ? 'bg-danger text-white' : 'bg-success text-white'
    );
    setToastMessage(message);
  };

  const closeModal = () => {
    const modalElement = document.getElementById('enquiry');
    const backdrop = document.querySelector('.modal-backdrop');

    if (modalElement) {
      modalElement.style.display = 'none';
      modalElement.classList.remove('show', 'modal-open');
    }
    if (backdrop) {
      backdrop.remove();
    }

    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  };

  const closeConfirmModal = () => {
    const backdrop = document.querySelector('.modal-backdrop');
    const confirmModal = document.getElementById('confirm');

    if (confirmModal) {
      confirmModal.style.display = 'none';
      confirmModal.classList.remove('show', 'modal-open');
    }
    if (backdrop) {
      backdrop.remove();
    }
  };

  const handleCloseToast = () => {
    setToastMessage('');
  };

  useEffect(() => {
    if (toastMessage) {
      if (toastClass === 'bg-danger text-white') {
        toast.error(toastMessage, {
          position: 'top-right',
          hideProgressBar: true,
          onClose: handleCloseToast,
          progress: undefined,
          toastId: '',
        });
      } else {
        toast.success(toastMessage, {
          position: 'top-right',
          hideProgressBar: true,
          onClose: handleCloseToast,
          progress: undefined,
          toastId: '',
        });
      }
    }
  }, [toastMessage, toastClass, contactUsError, contactUsSuccess]);

  return (
    <div className="listing-page px-2">
      {toastMessage && <ToastContainer autoClose={3000} limit={1} />}

      {loading ? (
        <div className="d-flex justify-content-center align-items-center">
          <Lottie
            animationData={Loader}
            loop={true}
            style={{ width: 300, height: '50vh' }}
          />
        </div>
      ) : (
        <>
          <section className="banner-section banner-slider pt-1 mb-1">
            <div className="container  d-none d-md-flex">
              <div className="home-banner">
                <div className="row align-items-center">
                  <div className="col-lg-6 my-2" data-aos="fade-down">
                    <h1 className="text-primary-dark text-center ">
                      {' '}
                      Cars List{' '}
                    </h1>
                  </div>
                  <div className="col-lg-6" data-aos="fade-down">
                    <div className="banner-imgs">
                      <ImageWithBasePath
                        src="assets/img/car-right.png"
                        className="img-fluid aos"
                        alt="bannerimage"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex d-md-none sign-group py-1 px-2">
              <Link
                to={routes.homeOne}
                className="border-0 text-primary-dark d-flex align-items-center mb-0"
              >
                <i className="bx bx-arrow-back fs-5 me-2"></i>

                <span className=""> Back </span>
              </Link>

              <div className="form-custom ps-2 w-100 d-md-none">
                <input
                  type="text"
                  name="searchText"
                  className="form-control py-2  mb-0"
                  placeholder="Search.."
                  defaultValue={searchText || ''}
                  onChange={(e) => setSearchText?.(e.target.value)}
                  id="member_search"
                />
                <span>
                  <div
                    onClick={handleSearchClick}
                    style={{ cursor: 'pointer' }}
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/search.svg"
                      alt="img"
                    />
                  </div>
                </span>
              </div>
            </div>

            <div className="d-flex justify-content-center page-search">
              <div className="container d-flex d-md-block align-items-center justify-content-between  g-2 m-0">
                <div
                  className={`search-box-banner mt-2`}
                  style={{
                    minWidth: '70%',
                    padding: '5px 30px',
                    margin: '15px 3px auto',
                    boxShadow: 'none',
                    border: '1px solid rgba(220, 220, 220, 0.55)',
                  }}
                >
                  <div className="row d-flex align-items-center">
                    <div className=" col-md-8  col-12 d-none d-md-flex">
                      <div className="count-search">
                        <div className="w-100 d-flex align-items-center gap-2">
                          <div className="d-flex align-items-center gap-2">
                            <div
                              className="form-custom "
                              style={{
                                background: 'none',
                              }}
                            >
                              <input
                                type="text"
                                name="searchText"
                                className="form-control py-1 mb-0"
                                defaultValue={searchText || ''}
                                style={{
                                  background: 'none',
                                }}
                                onChange={(e) =>
                                  setSearchText?.(e.target.value)
                                }
                                id="member_search"
                              />
                              <span>
                                <div
                                  onClick={handleSearchClick}
                                  style={{ cursor: 'pointer' }}
                                >
                                  <ImageWithBasePath
                                    src="assets/img/icons/search.svg"
                                    alt="img"
                                  />
                                </div>
                              </span>
                            </div>

                            <label
                              htmlFor="calendar-12h "
                              className="explore-text    block mb-0"
                              style={{ fontSize: '14px' }}
                            >
                              {' '}
                              From{' '}
                            </label>

                            <div className="d-flex gap-2">
                              <Calendar
                                minDate={today}
                                className=" datetimepicker"
                                value={startDate} // Should be a Date object
                                onChange={(e) => {
                                  const selectedDate = e.value as Date;

                                  setStartDate(selectedDate);

                                  if (
                                    selectedDate &&
                                    systemSettings?.booking_min_duration
                                  ) {
                                    const duration = parseInt(
                                      systemSettings.booking_min_duration
                                    );
                                    const calculatedEndDate = new Date(
                                      new Date(selectedDate).setDate(
                                        selectedDate.getDate() + duration
                                      )
                                    );
                                    setEndDate(calculatedEndDate);
                                  } else {
                                    setEndDate(null);
                                  }
                                }}
                                onHide={() => setShowCalendar(false)}
                                visible={showCalendar}
                                readOnlyInput
                              />
                              <select
                                value={fromTime}
                                onChange={(e) => {
                                  setFromTime(e.target.value);
                                  setUntilTime(e.target.value);
                                }}
                                className="form-select dynamic-select w-75 bg-white px-2"
                              >
                                {timeOptions.map((time, index) => (
                                  <option key={index} value={time}>
                                    {time}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="d-flex align-items-center gap-2">
                            <label
                              htmlFor="calendar-12h"
                              className="explore-text   block mb-0"
                              style={{
                                fontSize: '14px',
                              }}
                            >
                              {' '}
                              Until{' '}
                            </label>
                            <div className="d-flex gap-2">
                              <Calendar
                                className=" datetimepicker"
                                value={endDate} // Should be a Date object
                                minDate={
                                  startDate &&
                                  systemSettings?.booking_min_duration
                                    ? new Date(
                                        new Date(startDate).setDate(
                                          new Date(startDate).getDate() +
                                            parseInt(
                                              systemSettings.booking_min_duration
                                            )
                                        )
                                      )
                                    : undefined
                                }
                                onChange={(e) => setEndDate(e.value ?? null)}
                                onHide={() => setShowCalendar(false)}
                                visible={showCalendar}
                                readOnlyInput
                              />

                              <select
                                value={untilTime}
                                onChange={(e) => setUntilTime(e.target.value)}
                                className="form-select dynamic-select w-75  px-2"
                              >
                                {timeOptions.map((time, index) => (
                                  <option key={index} value={time}>
                                    {time}
                                  </option>
                                ))}
                              </select>
                            </div>{' '}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4   col-12 p-0">
                      <div className="product-filter-group">
                        <div className="sortbyset">
                          <ul className="d-none d-md-flex align-items-center gap-2 justify-content-end py-2">
                            {
                              <>
                                {' '}
                                <li className="d-flex align-items-center gap-2">
                                  <span className="sortbytitle">Show : </span>
                                  <div className="sorting-select select-one">
                                    <Dropdown
                                      value={limit}
                                      onChange={(e) =>
                                        dispatch(setLimit(e.value))
                                      }
                                      options={numberOptions}
                                      optionLabel="name"
                                      placeholder="5"
                                    />
                                  </div>
                                </li>
                                <li className="d-flex align-items-center gap-2">
                                  <span className="sortbytitle">Sort By </span>
                                  <div className="sorting-select select-two">
                                    <Dropdown
                                      value={
                                        sortDirection[
                                          formatLabel(
                                            sortBy,
                                            true
                                          )?.toLowerCase()
                                        ]
                                      }
                                      options={sortOptions}
                                      onChange={(e) =>
                                        handleSortChange(e.value)
                                      } // ✅ this is the correct way
                                      itemTemplate={(option) => (
                                        <div className="d-flex align-items-center gap-1 w-100">
                                          <i
                                            className={`bx ${
                                              sortDirection[option?.value] ===
                                              'asc'
                                                ? 'bx-up-arrow-alt text-success'
                                                : 'bx-down-arrow-alt text-danger'
                                            } fs-5`}
                                          ></i>
                                          {option.name}
                                        </div>
                                      )}
                                      valueTemplate={() => (
                                        <span className="d-flex align-items-center">
                                          <i
                                            className={`bx ${
                                              sortDirection[
                                                formatLabel(
                                                  sortBy,
                                                  false
                                                )?.toLowerCase()
                                              ] === 'asc'
                                                ? 'bx-up-arrow-alt text-success'
                                                : 'bx-down-arrow-alt text-danger'
                                            } fs-5 pe-1`}
                                          ></i>
                                          {formatLabel(sortBy, false)
                                            ? formatLabel(sortBy, false)
                                            : 'Popularity'}
                                        </span>
                                      )}
                                      placeholder="Sort by"
                                      className="w-100"
                                    />
                                  </div>
                                </li>
                              </>
                            }
                          </ul>
                        </div>

                        <div className="grid-listview  d-md-none">
                          <ul className="d-flex justify-content-between my-1">
                            <li className="d-flex justify-content-between align-items-center">
                              {/* <label className="text-primary-dark" >{paginationMeta}</label> */}
                              <div>
                                <p
                                  className="mb-0"
                                  style={{ fontSize: '14px' }}
                                  onClick={() => setOpen(!open)}
                                >
                                  {startDate && endDate
                                    ? `${dayjs(startDate).format('MMM DD')} ${fromTime} - ${dayjs(endDate).format('MMM DD')} ${untilTime}`
                                    : 'Select Date'}
                                </p>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="d-flex gap-2 align-items-center justify-content-end mt-2 me-1">
                  <Link
                    style={{
                      border: 'none',
                      background: 'none',
                      zIndex: 2,
                    }}
                    className="d-flex d-md-none text-primary-dark me-3"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasRight"
                    aria-controls="offcanvasRight"
                    to={'#'}
                  >
                    <i
                      className="feather icon-filter fs-12"
                      style={{
                        fontSize: 17,
                      }}
                    />
                  </Link>
                  <Link
                    style={{
                      border: 'none',
                      background: 'none',
                      zIndex: 2,
                    }}
                    className="d-flex d-md-none text-primary-dark me-1"
                    onClick={handleClick}
                    // data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight"
                    to={'#'}
                  >
                    <svg width="25" height="25" viewBox="0 0 256 256">
                      <path fill="none" d="M0 0h256v256H0z"></path>
                      <path
                        fill="none"
                        stroke="#111112"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="12"
                        d="m144 168 40 40 40-40M184 112v96M48 128h72M48 64h136M48 192h56"
                      ></path>
                    </svg>
                  </Link>
                </div>

                {open && (
                  <div
                    ref={popoverRef}
                    className="position-absolute w-100"
                    style={{
                      background: '#fff',
                      boxShadow: '0px 4px 10px rgba(0,0,0,0.15)',
                      borderRadius: '8px',
                      padding: '12px 0',
                      top: '100%',
                      left: '0%',
                      zIndex: 1000,
                    }}
                  >
                    <div className="w-100 p-2">
                      <div>
                        <span
                          className="d-flex float-end text-end"
                          onClick={() => {
                            setOpen(!open);
                          }}
                        >
                          {' '}
                          <i className="feather icon-x fs-5 " />
                        </span>
                      </div>

                      <div className="mt-1">
                        <label
                          htmlFor="calendar-12h "
                          className="explore-text    block mb-0"
                          style={{ fontSize: '12px' }}
                        >
                          {' '}
                          From{' '}
                        </label>

                        <div className="d-flex gap-2">
                          <Calendar
                            minDate={new Date()}
                            className="datetimepicker w-50"
                            value={startDate} // Should be a Date object
                            onChange={(e) => {
                              const selectedDate = e.value as Date;

                              setStartDate(selectedDate);

                              if (
                                selectedDate &&
                                systemSettings?.booking_min_duration
                              ) {
                                const duration = parseInt(
                                  systemSettings.booking_min_duration
                                );
                                const calculatedEndDate = new Date(
                                  new Date(selectedDate).setDate(
                                    selectedDate.getDate() + duration
                                  )
                                );
                                setEndDate(calculatedEndDate);
                              } else {
                                setEndDate(null);
                              }
                            }}
                            // Ensure e.value is a Date
                            onHide={() => setShowCalendar(false)}
                            visible={showCalendar}
                            readOnlyInput
                          />
                          <select
                            value={fromTime}
                            onChange={(e) => {
                              setFromTime(e.target.value);
                              setUntilTime(e.target.value);
                            }}
                            className="form-select dynamic-select w-50 px-2"
                          >
                            {timeOptions.map((time, index) => (
                              <option key={index} value={time}>
                                {time}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="">
                        <label
                          htmlFor="calendar-12h"
                          className="explore-text   block mb-0"
                          style={{
                            fontSize: '12px',
                          }}
                        >
                          {' '}
                          Until{' '}
                        </label>
                        <div className="d-flex gap-2">
                          <Calendar
                            className="datetimepicker w-50"
                            value={endDate} // Should be a Date object
                            minDate={
                              startDate && systemSettings?.booking_min_duration
                                ? new Date(
                                    new Date(startDate).setDate(
                                      new Date(startDate).getDate() +
                                        parseInt(
                                          systemSettings.booking_min_duration
                                        )
                                    )
                                  )
                                : undefined
                            }
                            onChange={(e) => {
                              setEndDate(e.value ?? null);
                            }}
                            onHide={() => setShowCalendar(false)}
                            visible={showCalendar}
                            readOnlyInput
                          />

                          <select
                            value={untilTime}
                            onChange={(e) => setUntilTime(e.target.value)}
                            className="form-select dynamic-select w-50   px-2"
                          >
                            {timeOptions.map((time, index) => (
                              <option key={index} value={time}>
                                {time}
                              </option>
                            ))}
                          </select>
                        </div>{' '}
                      </div>

                      <div className="d-flex gap-2 justify-content-end mt-2">
                        <button
                          className="btn btn-primary fs-12"
                          onClick={applyFilters}
                        >
                          Find
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                <Popover
                  id={id}
                  open={openFilter}
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                >
                  <div className="px-2 py-2">
                    {sortOptions?.map((option) => (
                      <p
                        key={option?.value}
                        onClick={() => handleSortChange(option?.value)}
                        className="d-flex align-items-center gap-1"
                      >
                        <i
                          className={`bx ${
                            sortDirection[option?.value] === 'asc'
                              ? 'bx-up-arrow-alt text-success'
                              : 'bx-down-arrow-alt text-danger'
                          } fs-5 `}
                        ></i>
                        {option?.name}
                      </p>
                    ))}
                  </div>
                </Popover>
              </div>
            </div>
          </section>

          {/* Car Grid View */}
          <section className="section car-listing pt-0">
            <div className="container">
              <div className="row">
                <MobileFilterSidebar
                  applyFilters={applyFilters}
                  searchText={searchText}
                  setSearchText={setSearchText}
                />

                <div className="col-lg-9">
                  {
                    <>
                      <div className="row">
                        {carsList.length > 0
                          ? carsList?.map((car: any, index: number) => (
                              <div
                                key={car?.vin}
                                className="col-xxl-4 col-lg-6 col-md-6 col-12"
                              >
                                <div className="listing-item">
                                  <div
                                    className="listing-img"
                                    onClick={() => {
                                      navigate(
                                        `${routes.listingDetails}/${car?.vin}?pickupDate=${dayjs(startDate).format('YYYY-MM-DD')}&pickupTime=${fromTime}&returnDate=${dayjs(endDate).format('YYYY-MM-DD')}&returnTime=${untilTime}`
                                      );
                                    }}
                                  >
                                    <div className="img-slider listing-page-slider">
                                      {car?.vehicle_image ? (
                                        <div className="fit-image-grid-container">
                                          <ImageWithBasePath
                                            src={car?.vehicle_image}
                                            alt={`Vehicle Image ${index + 1}`}
                                          />
                                        </div>
                                      ) : (
                                        <div className="no-slider-image">
                                          <ImageWithBasePath
                                            src="assets/img/cars/no_image.svg"
                                            className="img-fluid car-image"
                                            alt="Vehicle Image"
                                          />
                                        </div>
                                      )}
                                    </div>
                                    <div className="fav-item justify-content-end">
                                      <span className="img-count">
                                        <i className="feather icon-image" />
                                        {car?.images?.length}
                                      </span>
                                    </div>
                                    <span className="featured-text">
                                      {car?.car_category}
                                    </span>

                                    <span
                                      className="view-item justify-content-end"
                                      onClick={() => {
                                        navigate(
                                          `${routes.listingDetails}/${car?.vin}?pickupDate=${dayjs(startDate).format('YYYY-MM-DD')}&pickupTime=${fromTime}&returnDate=${dayjs(endDate).format('YYYY-MM-DD')}&returnTime=${untilTime}`
                                        );
                                      }}
                                    >
                                      <i className="feather icon-eye me-2" />
                                    </span>
                                  </div>
                                  <div className="listing-content">
                                    <div
                                      className="listing-features p-0 m-0 border-0 mb-3 d-flex align-items-end justify-content-between"
                                      onClick={() => {
                                        navigate(
                                          `${routes.listingDetails}/${car?.vin}?pickupDate=${dayjs(startDate).format('YYYY-MM-DD')}&pickupTime=${fromTime}&returnDate=${dayjs(endDate).format('YYYY-MM-DD')}&returnTime=${untilTime}`
                                        );
                                      }}
                                    >
                                      <div className="list-rating">
                                        <h3 className="listing-title">
                                          <Link
                                            to={`${routes.listingDetails}/${car.vin}`}
                                          >
                                            {car?.vehicle_name}
                                          </Link>
                                        </h3>

                                        <div className="listing-price">
                                          <i className="feather icon-map-pin" />

                                          <span className="text-secondary-dark">
                                            {' '}
                                            Dallas, Texas{' '}
                                          </span>
                                        </div>
                                      </div>
                                      <div className="listing-location-details justify-content-end px-2">
                                        <div className="listing-price">
                                          <h6>
                                            $
                                            {Math.round(
                                              Number(car?.price_per_day ?? 0)
                                            )}{' '}
                                            <span className="ms-1  me-0">
                                              /Day
                                            </span>
                                          </h6>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="listing-details-group mb-2"
                                      style={{
                                        borderTop: '1px solid #B3D5E0',
                                        padding: 10,
                                      }}
                                    >
                                      <ul>
                                        <li
                                          className="place-content-center"
                                          style={{
                                            placeContent: 'center',
                                          }}
                                        >
                                          <span>
                                            <ImageWithBasePath
                                              src="assets/img/home/seat.svg"
                                              alt="Persons"
                                            />
                                          </span>
                                          <p>
                                            {car?.seating_capacity ?? 0} Persons
                                          </p>
                                        </li>
                                        <li
                                          style={{
                                            placeContent: 'center',
                                          }}
                                        >
                                          <span>
                                            <ImageWithBasePath
                                              src="assets/img/home/wheel_steering.svg"
                                              alt={car?.series}
                                            />
                                          </span>
                                          <p>{'CarPlay'}</p>
                                        </li>

                                        <li
                                          style={{
                                            placeContent: 'center',
                                          }}
                                        >
                                          <span>
                                            <ImageWithBasePath
                                              src="assets/img/home/calendar.svg"
                                              alt={car?.total_bookings}
                                            />
                                          </span>
                                          <p>
                                            {car?.total_bookings}{' '}
                                            {car?.total_bookings === '1'
                                              ? 'Trip'
                                              : 'Trips'}{' '}
                                          </p>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>

                                  <div className="listing-button mx-2 mb-3 d-flex align-items-center justify-content-between gap-2">
                                    {car?.vehicle_current_status ===
                                    'Booked' ? (
                                      <Link
                                        to="#"
                                        onClick={() => {
                                          setSearchText('');
                                          findSimilarCars({
                                            body_style: car?.body_style,
                                            make: car?.make,
                                            price: selectedFilters?.price,
                                            vehicle_id: car.id,
                                          });
                                          dispatch(
                                            setSidebarFilters({
                                              body_style: car?.body_style,
                                              make: car?.make,
                                              price: selectedFilters?.price,
                                              vehicle_id: car.id,
                                            })
                                          );
                                        }}
                                        className="btn btn-primary w-100 py-1 align-items-center"
                                      >
                                        <span className="me-1">
                                          <FaCarSide size={18} />
                                        </span>
                                        Similar Cars
                                      </Link>
                                    ) : (
                                      <Link
                                        to={`${routes.bookingCheckout}/${car?.vin}?pickupDate=${dayjs(startDate).format('YYYY-MM-DD')}&pickupTime=${fromTime}&returnDate=${dayjs(endDate).format('YYYY-MM-DD')}&returnTime=${untilTime}`}
                                        className="btn btn-primary w-100 py-1 align-items-center"
                                      >
                                        <span className="me-1">
                                          <FaCalendarCheck size={14} />
                                        </span>
                                        Book
                                      </Link>
                                    )}

                                    <Link
                                      to="#"
                                      data-bs-toggle="modal"
                                      data-bs-target="#enquiry"
                                      className="btn btn-secondary w-100 py-1"
                                      onClick={() => setCarDetail(car)}
                                    >
                                      {car?.vehicle_current_status === 'Booked'
                                        ? 'Check Availability'
                                        : 'Get in touch'}
                                    </Link>
                                  </div>

                                  {car?.vehicle_current_status === 'Booked' && (
                                    <div className="feature-text">
                                      <span>{car?.vehicle_current_status}</span>
                                    </div>
                                  )}
                                </div>
                              </div>
                            ))
                          : !loading && (
                              <p className="text-center mb-0  fs-4 px-0 py-5">
                                No cars available.
                              </p>
                            )}
                      </div>
                      {/*Pagination*/}
                      <Pagination
                        currentPage={currentPage || 1}
                        totalPages={totalPages || 1}
                        onPageChange={handlePageChange}
                      />
                    </>
                  }
                </div>
              </div>
            </div>
          </section>

          <EnquiryForm
            carDetail={carDetail}
            handleSubmit={contactHandleSubmit}
            contactUsLoading={contactUsLoading}
            onSubmit={contactOnSubmit}
            register={contactRegister}
            errors={contactErrors}
            timeOptions={timeOptions}
            systemSettings={systemSettings}
            setShowCalendar={setShowCalendar}
            showCalendar={showCalendar}
            setStartDate={setAvailabilityStartDate}
            setEndDate={setAvailabilityEndDate}
            setFromTime={setAvailabilityFromTime}
            setUntilTime={setAvailabilityUntilTime}
            startDate={availabilityStartDate}
            endDate={availabilityEndDate}
            fromTime={availabilityFromTime}
            untilTime={availabilityUntilTime}
          />

          <ContactConfirm closeConfirmModal={closeConfirmModal} />
        </>
      )}
    </div>
  );
};

export default VehicleListGrid;
